import { apolloClient } from "@/plugins/vue-apollo.js";

const updateLandlordValidityPlan = async (_variables) => {
    // , limit, skip
  let responseFromApi;
  let variables = _variables;
  // debugger
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/landlord_validity_plan/update_landlord_validity_plan.graphql"),
      variables: variables,

      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/landlord_validity_plan/get_all_landlord_validity_plan.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        let allLandlordValidityPlan = store.readQuery(query);
        const findIndex = allLandlordValidityPlan.getAllLandlordValidityPlan.landlordValidityPlans.findIndex(
          (item) => item._id === data.updateLandlordValidityPlan._id
        );
        findIndex !== -1 &&
        allLandlordValidityPlan.getAllLandlordValidityPlan.landlordValidityPlans.splice(
            findIndex,
            1,
            data.updateLandlordValidityPlan
          );
        store.writeQuery({
          ...query,
          data: allLandlordValidityPlan,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { updateLandlordValidityPlan };
